import React from 'react';
import SvgImage from '@/components/Module/SvgImage';

type P = {
  opinionCount: number;
};

const Opinion = ({ opinionCount }: P) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <SvgImage name={'comments'} />
      <div style={{ lineHeight: '20px' }}>{opinionCount}</div>
    </div>
  );
};

export default Opinion;
